const getters = {
    journalentryline: (state) => state.journalentryline,
    id: (state) => state.id,
    loading: state => state.loading
};

export default getters;